import {randomKey} from 'common/src/utils/commonUtils';
import Subject from 'common/src/utils/pubsub/subject';
import {AgentBase, AgentSession} from '../../copilot.types';
import openAISystemMessage from '../../openAI/utils/openAISystemMessage';

export default function agentSession<TAgentType extends AgentBase = AgentBase>(
  agent: TAgentType,
): AgentSession<TAgentType> {
  return {
    sessionId: randomKey(),
    agent,
    agentContexts: {},
    memory: [openAISystemMessage(agent.instructions)],
    createdAtTimestamp: Date.now(),
    contextWindowUsage: new Subject(0),
  };
}
